// Hand-duplicated from shared/languages.js since frontend/src can't import outside src/
// under CRA's ModuleScopePlugin (see lib/languageSpeechConfig.js for the same pattern).
export const LANGUAGE_LOCALE_CODES = {
  English: 'en',
  Spanish: 'es',
  Mandarin: 'zh',
  Japanese: 'ja',
  French: 'fr',
  German: 'de',
  Italian: 'it',
  Korean: 'ko',
  Portuguese: 'pt',
  Arabic: 'ar',
};

const LOCALE_CODE_TO_LANGUAGE = Object.fromEntries(
  Object.entries(LANGUAGE_LOCALE_CODES).map(([name, code]) => [code, name])
);

export const matchSupportedLanguage = (deviceLocale) => {
  if (!deviceLocale) return 'English';
  const primary = String(deviceLocale).toLowerCase().split(/[-_]/)[0];
  return LOCALE_CODE_TO_LANGUAGE[primary] || 'English';
};
